import React from "react";
import BottomSaturdayDelivery from "./Bottom.saturdayDelivery";
import BottomWCExplanation from "./Bottom.WCExplanation";
import BottomShipCostInfo from "./Bottom.ShipCostInfo";
import BottomUnavailabeItems from "./Bottom.UnavailabeItems";

const MobileBottomNotifications = () => {
  return <>
    <BottomSaturdayDelivery/>
    <BottomWCExplanation/>
    <BottomShipCostInfo/>
    <BottomUnavailabeItems/>
  </>;
};

export default MobileBottomNotifications;
